import {MessageSend, MessageTypeLog} from '../../util/uiconstants';

const normalizeFrom = ({id: entityId, name: entityName}) => ({entityId, entityName});

export default (messagesList) => {
	let normalizeMessageLog = [];
	if (Array.isArray(messagesList)) {
		normalizeMessageLog = messagesList.map(
			({messageType, createdUserFirstName, createdUserLastName, createdDateTime, createdUserId, email = null, notification = null}) => {
				let result = null;
				const isEmail = messageType === MessageSend.Email;
				const message = {
					messageTypeId: isEmail? MessageTypeLog.Email : MessageTypeLog.Notifcation,
					messageType,
					sentByUserId: createdUserId,
					sentBy: `${createdUserFirstName} ${createdUserLastName}`,
					createdDateTime,
					createdUserFirstName,
					createdUserLastName
				};

				if (isEmail && email !== null) {
					const {
						fromEntity: from,
						subject,
						contacts,
						entities,
						countries,
						groupRoles,
						engagements,
						serviceLine,
						roles
					} = email;
					const emailObj = {
						from: normalizeFrom(from),
						subject,
						contacts,
						entities,
						countries,
						groupRoles,
						engagements,
						serviceLine,
						roles
					};
					result = {...message, ...emailObj};
				}

				if (notification !== null) {
					const {
						fromEntity: from,
						toastMessage: subject,
						contacts,
						entities,
						countries,
						groupRoles,
						engagements,
						serviceLine,
						roles,
						fromEngagement,
						message: notificationMessage,
						linkLabel,
						link
					} = notification;
					const notifiactionObj = {
						from: normalizeFrom(from),
						subject,
						contacts,
						entities,
						countries,
						groupRoles,
						engagements,
						serviceLine,
						roles,
						fromEngagement,
						message: notificationMessage
					};
					if (linkLabel) {
						notifiactionObj.link = {
							label: linkLabel,
							link
						};
					}
					result = {...message, ...notifiactionObj};
				}
				
				return result;
			}
		);
	}
	return normalizeMessageLog;
};
